import styled from '@emotion/styled';
import type { FC } from 'react';

import Tooltip from '../../Tooltip';
import Typography from '../../Typography';
import type { TextCellProps } from '../types';

const TextContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: 2,
  minWidth: 0,
  overflow: 'hidden',
});

const Caption = styled(Typography)(({ theme }) => ({
  color: theme.colors.white[60],
}));

export const TextCell: FC<TextCellProps> = ({ title, caption, tooltip }) => {
  return (
    <>
      <TextContainer>
        <Tooltip title={tooltip} disabled={!tooltip}>
          <Typography variant="body2" fontWeight={500} as="label" noWrap>
            {title}
          </Typography>
        </Tooltip>
        {caption && (
          <Caption variant="body3" as="label" noWrap>
            {caption}
          </Caption>
        )}
      </TextContainer>
    </>
  );
};

TextCell.displayName = 'TextCell';
